import Footer from '../components/Footer';
import SEO from '../components/SEO';
import SplitHeadline from '../components/Reusable/SplitHeadline';

function Datenschutz() {
  return (
    <>
      <SEO title="Datenschutz" description="Datenschutzerklärung – Catalina Mejia Martinez" />

      <main className="mainContent">
        <div className="max-width legal-page">

          <SplitHeadline tag="h1" start="top 90%">Datenschutz&shy;erklärung</SplitHeadline>

          <section>
            <h2>1. Datenschutz auf einen Blick</h2>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
              personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene
              Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
              Ausführliche Informationen zum Thema Datenschutz entnehmen Sie den nachfolgenden
              Abschnitten dieser Datenschutzerklärung.
            </p>
          </section>

          <section>
            <h2>2. Verantwortliche Stelle</h2>
            <p>
              Catalina Mejia Martinez<br />
              c/o Leicht Digital GmbH<br />
              Innsbrucker Str. 37<br />
              10825 Berlin<br />
              Deutschland<br />
              E-Mail: kontakt@cmmvisual.de
            </p>
            <p>
              Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder
              gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von
              personenbezogenen Daten entscheidet (Art. 4 Nr. 7 DSGVO).
            </p>
          </section>

          <section>
            <h2>3. Datenerfassung auf dieser Website</h2>
            <p>
              Beim Besuch dieser Website werden durch den Webhoster automatisch technische
              Zugriffsdaten erfasst (sog. Server-Logfiles). Dazu gehören Browsertyp und
              -version, verwendetes Betriebssystem, Referrer-URL, Hostname des zugreifenden
              Rechners sowie Uhrzeit der Serveranfrage. Diese Daten sind nicht bestimmten
              Personen zuordenbar. Eine Zusammenführung dieser Daten mit anderen Datenquellen
              wird nicht vorgenommen.
            </p>
            <p>
              Darüber hinaus werden Daten nur dann erhoben, wenn Sie diese aktiv mitteilen,
              z.&nbsp;B. durch das Ausfüllen des Kontaktformulars.
            </p>
          </section>

          <section>
            <h2>4. Hosting</h2>
            <p>
              Diese Website wird über <strong>Vercel Inc.</strong> (340 Pine Street, Suite 701,
              San Francisco, CA 94104, USA) gehostet. Beim Aufruf der Website werden automatisch
              Verbindungsdaten (IP-Adresse, Browsertyp, Zeitstempel) an Vercel übermittelt. Der
              Einsatz von Vercel erfolgt auf Grundlage von Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f
              DSGVO (berechtigtes Interesse an einem zuverlässigen Betrieb der Website) sowie
              Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO (Vertragserfüllung). Mit Vercel besteht
              ein Auftragsverarbeitungsvertrag (Data Processing Agreement) gemäß
              Art.&nbsp;28 DSGVO. Weitere Informationen finden Sie in der{' '}
              <a
                href="https://vercel.com/legal/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Datenschutzerklärung von Vercel
              </a>.
            </p>
          </section>

          <section>
            <h2>5. Cookies</h2>
            <p>
              Diese Website verwendet ausschließlich technisch notwendige Cookies. Dabei handelt
              es sich um ein einzelnes Cookie, das Ihre Cookie-Einwilligung im lokalen Speicher
              Ihres Browsers speichert (<code>cmm_cookie_consent</code>). Dieses Cookie ist für
              den ordnungsgemäßen Betrieb des Cookie-Hinweises erforderlich und enthält keine
              personenbezogenen Daten. Es werden keine Tracking-, Werbe- oder
              Analyse-Cookies eingesetzt.
            </p>
            <p>
              Rechtsgrundlage für die Verarbeitung ist Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f
              DSGVO (berechtigtes Interesse). Sie können Cookies jederzeit in den
              Einstellungen Ihres Browsers löschen oder blockieren.
            </p>
          </section>

          <section>
            <h2>6. Google Fonts</h2>
            <p>
              Diese Website bindet Schriftarten des Dienstes Google Fonts (Google LLC,
              1600 Amphitheatre Parkway, Mountain View, CA 94043, USA) ein. Beim Laden der Seite
              stellt Ihr Browser eine Verbindung zu den Google-Servern her, wodurch Ihre
              IP-Adresse an Google übermittelt werden kann. Rechtsgrundlage ist
              Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO (berechtigtes Interesse an einer
              einheitlichen Darstellung der Website). Weitere Informationen finden Sie in der{' '}
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Datenschutzerklärung von Google
              </a>.
            </p>
          </section>

          <section>
            <h2>7. Kontaktformular (Web3Forms)</h2>
            <p>
              Wenn Sie das Kontaktformular auf dieser Website nutzen, werden Ihre Angaben
              (Name, E-Mail-Adresse, Betreff, Nachricht) an den Dienst{' '}
              <strong>Web3Forms</strong> (Arengu Inc.) übermittelt und zur Bearbeitung Ihrer
              Anfrage per E-Mail an uns weitergeleitet. Die Daten werden ausschließlich zur
              Beantwortung Ihrer Kontaktanfrage verwendet und nicht ohne Ihre Einwilligung an
              Dritte weitergegeben.
            </p>
            <p>
              Rechtsgrundlage ist Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;b DSGVO (Durchführung
              vorvertraglicher Maßnahmen) sowie Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO
              (berechtigtes Interesse an der Kommunikation mit Anfragenden). Die über das
              Formular übermittelten Daten verbleiben bei uns, bis Sie uns zur Löschung
              auffordern oder der Zweck der Speicherung entfällt. Gesetzliche
              Aufbewahrungspflichten bleiben unberührt. Weitere Informationen finden Sie in der{' '}
              <a
                href="https://web3forms.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Datenschutzerklärung von Web3Forms
              </a>.
            </p>
          </section>

          <section>
            <h2>8. Analyse-Tools und Werbung</h2>
            <p>
              Diese Website verwendet keine Analyse-Tools von Drittanbietern (z.&nbsp;B. Google
              Analytics) und schaltet keine Werbung. Es werden keine personenbezogenen Daten
              zu Werbe- oder Trackingzwecken an Dritte weitergegeben.
            </p>
          </section>

          <section>
            <h2>9. Ihre Rechte</h2>
            <p>
              Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden
              personenbezogenen Daten:
            </p>
            <ul>
              <li>Recht auf Auskunft (Art.&nbsp;15 DSGVO)</li>
              <li>Recht auf Berichtigung (Art.&nbsp;16 DSGVO)</li>
              <li>Recht auf Löschung (Art.&nbsp;17 DSGVO)</li>
              <li>Recht auf Einschränkung der Verarbeitung (Art.&nbsp;18 DSGVO)</li>
              <li>Recht auf Datenübertragbarkeit (Art.&nbsp;20 DSGVO)</li>
              <li>Recht auf Widerspruch gegen die Verarbeitung (Art.&nbsp;21 DSGVO)</li>
              <li>
                Recht auf Widerruf einer erteilten Einwilligung jederzeit für die Zukunft
                (Art.&nbsp;7 Abs.&nbsp;3 DSGVO)
              </li>
            </ul>
            <p>
              Sie haben außerdem das Recht, sich bei der zuständigen Aufsichtsbehörde zu
              beschweren. In Berlin ist dies die{' '}
              <strong>
                Berliner Beauftragte für Datenschutz und Informationsfreiheit
              </strong>{' '}
              (Friedrichstr. 219, 10969 Berlin). Zur Geltendmachung Ihrer Rechte wenden Sie
              sich bitte an: kontakt@cmmvisual.de
            </p>
          </section>

          <section>
            <h2>10. Datensicherheit</h2>
            <p>
              Diese Website nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung.
              Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des
              Browsers von „http://" auf „https://" wechselt und am Schloss-Symbol in Ihrer
              Browserzeile. Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die
              Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.
            </p>
          </section>

        </div>
      </main>

      <Footer />
    </>
  );
}

export default Datenschutz;
